import styled from 'styled-components/macro'
import { Container as ContainerBase } from 'components/container'
import { styleReset } from 'styles/misc'
import { theme } from 'styles/theme'
import { Modal as ModalBase } from 'components/modal'
import { mq } from 'styles/mq'

export const Modal = styled(ModalBase)`
  // background-color: ${theme.colors.accent.rfe};
  background: #fb6200
    url(https://gdb.rferl.org/069c0000-0aff-0242-72cd-08db048a696d.jpg)
    no-repeat center;
  background-size: cover;
`

export const Container = styled(ContainerBase)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100%;
  color: white;
  text-align: center;
  font-size: 1.8rem;
  line-height: 1.5;

  ${mq.large} {
    font-size: 2.4rem;
  }
`

export const Logos = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  list-style: none;
  max-width: 100%;

  > li {
    padding: 1rem 3rem;

    ${mq.large} {
      padding: 2rem 4rem;
    }

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }

    &:not(:first-child) {
      border-left: 1px solid currentColor;
    }
  }

  svg {
    max-width: 100%;
  }
`

export const Title = styled.h1`
  font-weight: 800;
  margin: 3rem 0 00;
  font-size: clamp(3.7rem, 8vw, 9.6rem);
  text-transform: uppercase;
  line-height: 1;

  span {
    display: block;
    padding-top: 0.3em;
    font-size: 0.57em;
    font-weight: normal;
  }
`

export const Content = styled.div`
  max-width: 38em;
  margin: 0 auto;
`

export const Button = styled.button`
  ${styleReset}
  display: block;
  width: 100%;
  margin-top: 4rem;
  padding: 2rem 1rem 1.2rem;
  text-transform: uppercase;
  font-size: 2.2rem;
  cursor: pointer;
  background-color: #1f2124;

  ${mq.medium} {
    display: inline-block;
    width: auto;
    padding-left: 5rem;
    padding-right: 5rem;
  }

  ${mq.large} {
    font-size: 3.2rem;
  }
`
